import cookies from "js-cookie";

export const setLang = (lang) => {
  const langCookie = cookies.get("i18next");
  const url = location.pathname.split("/");
  url.splice(1, 1, langCookie);
  window.history.pushState({}, "", url.join("/"));
  return lang;
};

export const getLang = () => {
  return localStorage.getItem("lang");
};

export default setLang;
getLang;
